import React from "react";
import {FormattedNumber} from "../../common/ui/FormattedNumber";

/**
 * @param {{
 *   header: {
 *     id: number,
 *     code: string,
 *     name: string,
 *     provider: string,
 *     availability: { isAvailable: boolean, msg?: string },
 *     price: { value: number, bestPrice: number, discount?: number, discountLine?: string }
 *   },
 *   children?: React.ReactNode
 * }} props
 */
export const ProductDetailHeader = ({header, children}) => {
    const {id, code, name, provider, availability, price} = header;

    const basePrice = Number(price?.value ?? 0);
    const bestPrice = Number(price?.bestPrice ?? basePrice);
    const showOldPrice = basePrice > 0 && bestPrice > 0 && basePrice > bestPrice;

    const trackChild = React.Children.toArray(children)
        .find(child => React.isValidElement(child) && child.type === ProductDetailHeader.Track)

    return (
        <section className="pb-3" aria-labelledby={`product-title-${id}`}>
            <div className="row g-3 align-items-start">
                <div className="col-12">
                  <span
                      className={`badge rounded-pill fs-6 fw-normal ${
                          availability.isAvailable ? "text-bg-primary" : "bg-warning text-light "
                      }`}
                  >
                    {availability.msg}
                  </span>
                </div>

                <div className="col-lg">
                    <h1 id={`product-title-${id}`} className="h4 mb-1 fw-bold text-uppercase">
                        {name}
                    </h1>
                    <div className="text-muted small">
                        {provider && <span className="me-2">{provider}</span>}
                        {code && <span>Ref: {code}</span>}
                    </div>
                </div>

                <div className="col-12 d-flex flex-wrap align-items-end justify-content-between gap-3 mt-2">
                    <div className="d-flex flex-column flex-wrap align-items-start mt-2">
                        {price && (
                            <>
                                <div className="d-flex align-items-end gap-3">
                                    <div className="d-flex align-items-end">
                                    <span className="fs-3 fw-semibold me-1">
                                        <FormattedNumber value={bestPrice} config={{style: "currency"}}/>
                                    </span>
                                        <span className="text-muted small">/ unidad</span>
                                    </div>
                                    {showOldPrice && (
                                        <del className="text-danger small">
                                            <FormattedNumber value={basePrice} config={{style: "currency"}}/>
                                        </del>
                                    )}
                                </div>

                                {!!price.discountLine && (
                                    <div className="text-muted small">
                                        <span className="me-1">Ahorro cliente:</span>
                                        <span
                                            className="text-primary fw-semibold">{price.discountLine.replace('.', ',')}</span>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {trackChild || <></>}
                </div>
            </div>
        </section>
    );
};

ProductDetailHeader.Track = ({children}) => <>{children}</>;
